'use client';

import { ArrowRight } from 'lucide-react';
import Link from 'next/link';
import { useAnalytics } from '@/services/frontendAnalyticsService';

interface ArticleKonsolidasiCTAProps {
  postSlug: string;
  regulationCount?: number;
  firstRegulationId?: string | null;
}

export function ArticleKonsolidasiCTA({
  postSlug,
  regulationCount = 0,
  firstRegulationId,
}: ArticleKonsolidasiCTAProps) {
  const analytics = useAnalytics();
  const descriptionText =
    regulationCount >= 2
      ? `${regulationCount} peraturan terkait dalam kajian ini — lihat bagaimana masing-masing mengubah aturan sebelumnya dalam satu naskah.`
      : 'Peraturan yang sudah diubah berkali-kali sulah dibaca utuh. Justisio menyatukan semua riwayat perubahan dalam satu tampilan.';

  const ctaLink = firstRegulationId
    ? `/regulation/indonesia/${firstRegulationId}`
    : '/legal-tasks/action/consolidation-list';

  const handleClick = () => {
    analytics.blog.featuresCTAClicked({
      postSlug,
      ctaType: 'konsolidasi',
      ctaLabel: 'Lihat Konsolidasi',
    });
  };

  return (
    <div className="not-prose my-12 bg-white border-2 border-black overflow-hidden md:max-w-[450px] md:mx-auto">
      <div className="p-6 md:p-8">
        <h3 className="text-2xl md:text-3xl font-bold text-black mb-3 leading-tight uppercase font-sans tracking-tight">
          Peraturan Berubah Terus?
          <br />
          Baca Versi Terbaru Sekali Klik.
        </h3>

        <p className="text-gray-700 font-medium mb-6">
          {descriptionText}
        </p>

        <Link
          href={ctaLink}
          onClick={handleClick}
          className="inline-flex items-center justify-center gap-2 bg-amber-600 text-white px-6 py-4 font-bold text-sm md:text-base border-2 border-black hover:bg-amber-700 transition-all hover:-translate-y-0.5"
        >
          Lihat Konsolidasi
          <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </div>
  );
}
